import React from 'react'
import { Auth_Domain, Auth_Port, Auth_Proto } from '../../Component/consts';
import axios from 'axios';

class DirectDNCNServices {
    getallcndn(tenantId){
        return axios.get(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/appmasters/getallcndn/${tenantId}`)
       }
     
       generatedirectcndn(data){
        return axios.post(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/appmasters/generatedirectcndn`,data)
       }

       approvedirectcndn(id,status){
        return axios.put(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/appmasters/approvedirectcndn/${id}/${status}`)
       }    

       updateaccentrystatusofdirectcndn(id){
        return axios.put(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/appmasters/updateaccentrystatusofdirectcndn/${id}`)
       }
}
export default new DirectDNCNServices();
